import { Space } from 'antd';
import React from 'react';

interface IconTitleProps {
  icon: React.ReactNode;
  text: string;
}

export const IconTitle: React.FC<IconTitleProps> = ({ icon, text }) => {
  return (
    <Space size={4}>
      {icon}
      <span>{text}</span>
    </Space>
  );
};
